<template>
	<v-row no-gutters v-if="connectionData" align="center" class="list_item pt-3" style="cursor: pointer" @click="showDialog">
		<v-col cols="auto">
			<v-card class="ac_card integration inline-block">
				<div class="centerdXY">
					<v-img class="place-self-center" :src="src" :width="15" />
				</div>
			</v-card>
		</v-col>
		<v-col class="pl-3 mb-[8px] h-full justify-between flex-col">
			<h3 class="d_name light">
				<span class="text-[14px] font-normal text-[#1B1C21]">{{ connectionData.title }}</span>
			</h3>
			<p class="display-flex flex-row flex-align-center">
				<ProjectChip :alwaysShowProjectChip="alwaysShowProjectChip" :projectId="connectionData.project" />
				{{ providerName }}
			</p>
		</v-col>
		<v-col class="text-right">
			<div class="test_wrpr text-right">
				<AppDropdownMenu
					left
					bottom
					absolute
					min-width="200"
					content-class="men"
					:items="menuItems"
					v-if="menuItems && menuItems.length !== 0"
				>
					<template #activator>
						<AnemicButton
							@click="(e) => e.preventDefault()"
							width="22"
							height="22"
							icon
							fab
							x-small
							class="flex-centerize menu-button mr-2"
						>
							<SIcon name="three-dot-menu" width="13" class="menu-icon" />
						</AnemicButton>
					</template>
					<template #list-item="{ item }">
						<span
							v-if="!item.divider"
							style="color: #3e495a; font-size: 14px; font-weight: 400"
							:style="{ fontWeight: item.text === 'Edit' ? 600 : 400 }"
						>
							{{ item.text }}
						</span>
					</template>
				</AppDropdownMenu>
			</div>
		</v-col>
	</v-row>
</template>

<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { deleteAnalyticsConfiguration } from '@/store/modules/analyticsProvider/actions';
import { useAnalyticsProviders } from '@/store/modules/analyticsProvider/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import ProjectChip from '@/views/Flow/ProjectChip.vue';

export default {
	name: 'SettingsTrackingListItem',
	components: { ProjectChip },
	props: {
		connectionData: { type: Object },
		src: { type: String },
		alwaysShowProjectChip: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ useAnalyticsProviders }),
		menuItems() {
			return [
				{ onClick: this.showDialog, text: 'Edit Events' },
				{ onClick: this.openSettings, text: 'Settings' },
				{ onClick: this.deleteConfiguration, text: 'Delete' },
			];
		},
		providerName() {
			return this.useAnalyticsProviders[this.connectionData.analytics_provider].provider_name;
		},
	},
	methods: {
		...mapActionsShorthand({ deleteAnalyticsConfiguration }),
		showDialog() {
			AppDialogManagerService.openAnalyticsEventTrackingItemDialog({ pixelConfiguration: this.connectionData });
		},
		openSettings() {
			AppDialogManagerService.openAnalyticsEventTrackingSettingsDialog({ currentConnection: this.connectionData });
		},
		deleteConfiguration() {
			this.deleteAnalyticsConfiguration({ analyticsConfigurationId: this.connectionData.id });
		},
	},
};
</script>

<style scoped lang="scss">
.ac_card {
	width: 43px;
	height: 43px !important;
	border-color: #e1e1e1 !important;
}
p {
	font-size: 12px;
	color: #919191;
	line-height: 15px;
}
.menu_btn {
	border: 1px solid #959da1 !important;
	width: 25px;
	height: 25px;
	background-color: var(--page-background);
	transition: all 0.2s;
	opacity: 0;
	position: absolute;
	margin-left: 3px;
}
.edit_name {
	width: 21px;
	height: 21px;
	opacity: 0;
	background: #f0f1f3 !important;
	transition: 0.2s;
	position: absolute;
	right: 0px;
	top: 0px;
}
.list_item {
	background: var(--bg-color);
	&:hover {
		transition: 0.1s;
		background: #f5f5f5;
	}
}
.menu-button {
	background: transparent !important;
	&:hover {
		border: 1px solid var(--forth-border-color);
	}
	.menu-icon {
		margin-left: 1px;
	}
	position: relative;
	display: inline-block;
}
.list_item:hover .menu_btn {
	opacity: 1;
}
.list_item:hover .edit_name {
	opacity: 1;
}
.u_icon {
	transform: scale(0.8);
	display: inline-block;
	vertical-align: middle;
}
.test_btn {
	text-transform: capitalize !important;
	font-weight: 400 !important;
	font-size: 14px !important;
	border-radius: 2px !important;
}
span.flows_list:not(.unactive):hover {
	color: #5c8df5 !important;
}
span.flows_list.unactive {
	cursor: default;
	pointer-events: none;
}
.edit_name_tf {
	position: relative;
	width: 300px;
	top: 0px;
	left: 0px;
}
.d_name {
	line-height: 18px;
	position: relative;
	display: inline-block;
	padding-right: 30px;
}
.d_name span {
	margin-top: 3px;
	position: relative;
}

.det_btn {
	background: rgba(233, 78, 78, 0.15) !important;
	font-size: 12px !important;
	padding: 1px 10px !important;
}

.test_wrpr {
	position: relative;
	display: inline-block;
	width: 100px;
	height: 26px;
	vertical-align: middle;
	font-size: 14px;
}
.test_wrpr.t_failed {
	width: 270px;
}
/*.test_wrpr.failed{width: 350px}*/
.succ {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	text-align: center;
}
.succ span {
	color: #1bbc9c;
	font-size: 14px;
}
.failed {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	text-align: right;
}
.failed span {
	color: #e94e4e;
}
.test-button {
	width: 70px !important;
	height: 26px !important;
	border-radius: 8px !important;
	color: var(--bold-border-color);
	background: transparent !important;
	border: 1px solid var(--bold-border-color);
}
</style>
